var map = {
	"./弓箭.jpg": 1302,
	"./微型冲锋枪.jpg": 1311,
	"./手枪.jpg": 1750,
	"./手炮.jpg": 428,
	"./斥候步枪.jpg": 544,
	"./脉冲步枪.jpg": 7461,
	"./自动步枪.jpg": 8837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7136;